import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import BigBox from '../BigBox.js';
import DealerGraph from './DealerGraph.js';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const DealerOverview = () => {
  const [chartData, setChartData] = useState([]);
  const [dealerTierName, setDealerTierName] = useState('');
  const [businessTimeframe, setBusinessTimeframe] = useState("MTD");

  const res = useSelector((state) => state.tierPerformance.tierPerformance);
  const loading = !res;

  useEffect(() => {
    if (!res) return;

    if (res.success === true) {
      const result = res?.response?.data;

      const format_data = result?.sales.map(element => {
        const monthShort = element?.month_name.length > 2
          ? `${element?.month_name.substring(0, 3)}`
          : `${element?.month_name.substring(0, 1)}`;
        const label = `${monthShort.toUpperCase()} ${String(element?.year).slice(-2)}`;

        return {
          value: Number(element?.totalSales),
          label,
        };
      });

      setDealerTierName(result?.tierDetails?.[0]?.tier_name || '');
      setChartData(format_data.reverse());
    } else {
      setChartData([]);
    }
  }, [res]);

  const changeBusinessTimeFrameService = (option) => {
    setBusinessTimeframe(option);
  };



  return (
    <div className="w-100">
      <BigBox 
        header={'Dealer Analytics'}
        options={['MTD', 'YTD']}
        selectedOption={businessTimeframe}
        onChange={changeBusinessTimeFrameService}
      />
      
      {loading ? (
        <p>Loading dealer chart...</p>
      ) : (
        <DealerGraph
          chartData={chartData}
          dealerTierName={dealerTierName}
        />
      )}
    </div>
  );
};

export default DealerOverview;

